import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import { ptBR } from '../i18n/pt-BR';

export default function ProtectedRoute() {
  const { user, isLoading } = useAuth();

  if (isLoading) return <p>{ptBR.common.loading}</p>;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
